export var ActionType;
(function (ActionType) {
    ActionType[ActionType["undo_color"] = 0] = "undo_color";
    ActionType[ActionType["redo_color"] = 1] = "redo_color";
    ActionType[ActionType["add_color"] = 2] = "add_color";
    ActionType[ActionType["update_value"] = 3] = "update_value";
    ActionType[ActionType["reset"] = 4] = "reset";
})(ActionType || (ActionType = {}));
